// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

export const DEFAULT_REQUEST_TIMEOUT_MS = 30_000;

export const LONG_REQUEST_TIMEOUT_MS = 120_000;

export function requestTimeoutSignal(timeoutMs: number): AbortSignal | undefined {
  return typeof AbortSignal !== "undefined" && typeof AbortSignal.timeout === "function"
    ? AbortSignal.timeout(timeoutMs)
    : undefined;
}

export function longRequestSignal(): { signal?: AbortSignal } {
  const signal = requestTimeoutSignal(LONG_REQUEST_TIMEOUT_MS);
  return signal === undefined ? {} : { signal };
}
